import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'

export default {
  name: 'project',
  props: [],
  components: {
    Header,
  },
  data() {
    return {
      project: {
        name: "",
        description: "",
        price: "",
        country: "",
        size: "",
        user: "", // it's user id
        address: "",
        images: [],
        latitude: null,
        longitude: null,
      },
      validationMessage: '',
      displayFirstPage: true,
    }
  },
  methods: {
    setHeightImage () {
      var pic_box = $('.picture-box');
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight;
        pic_box[0].style.height = (h > screen.availHeight ? (h - 80) : (screen.availHeight - 80)) + 'px';
      }
    },
    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize (event) {
      this.setHeightImage();
    },
    firstSave () {
      this.displayFirstPage = false;
    },
  },
  computed: { },
  beforeCreate() { },
  created() { },
  mounted: function () {
   
    this.setHeightImage();

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
}


// WEBPACK FOOTER //
// ./src/components/Account/RejectLetter/RejectLetter.component.js